import { CurrentPosition } from './components/CurrentPosition';
import { HistoricalSearch } from './components/HistoricalSearch';

export type Fields = {
  label: string;
  value: number;
};

export const transactionFlowTabs = {
  positionToday: {
    label: 'Posição atual',
    component: CurrentPosition,
  },
  positionHistory: {
    label: 'Busca Histórica',
    component: HistoricalSearch,
  },
};

export const transactionFlowProducts = [
  { key: 'funds', label: 'Fundos de investimento', color: 'product.fundos' },
  { key: 'fixedIncome', label: 'Renda Fixa', color: 'product.rf' },
  { key: 'variableIncome', label: 'Renda Variável', color: 'product.rendavariavel' },
  { key: 'treasury', label: 'Tesouro direto', color: 'product.tesouro' },
  { key: 'publicOffer', label: 'Oferta Pública', color: 'product.ofertapublica' },
  { key: 'currentAccount', label: 'Conta Corrente', color: 'product.contacorrente' },
  { key: 'requiredMargin', label: 'Margem Requerida', color: 'product.margemrequerida' },
];

export type TransactionFlowProductsType = (typeof transactionFlowProducts)[0];

export type TransactionFlowAvailableTabs = keyof typeof transactionFlowTabs;

export const transactionFlowTabsKeys = Object.keys(transactionFlowTabs);
export const transactionFlowInitialTab = transactionFlowTabsKeys[0] as TransactionFlowAvailableTabs;

export const getRenderFields = (key: string, data): Fields[] => {
  switch (key) {
    case 'funds':
      return [
        { label: 'Resgate', value: data.totalRedemption },
        { label: 'Aplicação', value: data.totalApplication },
      ];
    case 'fixedIncome':
      return [
        { label: 'Resgate', value: data.totalRedemption },
        { label: 'Aplicação', value: data.totalApplication },
      ];
    case 'variableIncome':
      return [
        { label: 'Venda', value: data.totalSale },
        { label: 'Compra', value: data.totalPurchase },
      ];
    case 'treasury':
      return [
        { label: 'Resgate', value: data.totalRedemption },
        { label: 'Aplicação', value: data.totalApplication },
      ];
    case 'publicOffer':
      return [
        { label: 'Reservado', value: data.totalReserved },
        { label: 'Liquidado', value: data.totalSettled },
      ];
    case 'currentAccount':
      return [
        { label: 'Saque', value: data.totalWithdrawal },
        { label: 'Aporte', value: data.totalDeposit },
      ];
    case 'requiredMargin':
      return [
        { label: 'Requerido', value: data.totalRequired },
        { label: 'Em garantia', value: data.totalGuarantee },
      ];
    default:
      return [];
  }
};
